import { Component, ElementRef, Input } from '@angular/core';
var ResizingCroppingImagesComponent = (function () {
    /**
     * @param {?} elementRef
     */
    function ResizingCroppingImagesComponent(elementRef) {
        this.elementRef = elementRef;
        this._format = 'jpeg';
        this.img = null;
        this.sizeW = 150;
        this.sizeH = 150;
        this.sizeWmax = 720;
        this.sizeHmax = 720;
        this.stateMouse = false;
        this.stateType = 'none';
        this.stateR = 'none';
        this.centerX = 0;
        this.centerY = 0;
        this.percent = 100;
        this.imgUrl = null;
        this._top = 0;
        this._left = 0;
        this._img = {};
        this._src = null;
        // this._log.setLog('ResizingCroppingImages');
    }
    Object.defineProperty(ResizingCroppingImagesComponent.prototype, "styleCrop", {
        /**
         * @return {?}
         */
        get: function () {
            return {
                // color: `${this.palette.accent.color}`,
                // background: `${this.palette.accent.color}`,
                color: "#00bcd4",
                background: "#00bcd4",
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResizingCroppingImagesComponent.prototype, "format", {
        /**
         * @return {?}
         */
        get: function () {
            return this._format;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._format = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    ResizingCroppingImagesComponent.prototype.ngOnChanges = function (changes) {
        // console.log('change stdsf');
    };
    /**
     * @param {?} state
     * @return {?}
     */
    ResizingCroppingImagesComponent.prototype.zoom = function (state) {
        var /** @type {?} */ W = this.elementRef.nativeElement.querySelector('._img').offsetWidth;
        var /** @type {?} */ H = this.elementRef.nativeElement.querySelector('._img').offsetHeight;
        var /** @type {?} */ oTop = this.elementRef.nativeElement.querySelector('._img').offsetTop;
        var /** @type {?} */ oLeft = this.elementRef.nativeElement.querySelector('._img').offsetLeft;
        this.stateType = 'resize';
        this.stateR = state;
        this.resize(0, W, H, oTop, oLeft);
    };
    /**
     * @param {?} $e
     * @return {?}
     */
    ResizingCroppingImagesComponent.prototype.startMove = function ($e) {
        var /** @type {?} */ oTop = this.elementRef.nativeElement.querySelector('._img').offsetTop;
        var /** @type {?} */ oLeft = this.elementRef.nativeElement.querySelector('._img').offsetLeft;
        this.centerX = $e.clientX -
            offset(this.elementRef.nativeElement.querySelector('.content-img')).left - oLeft;
        this.centerY = $e.clientY -
            offset(this.elementRef.nativeElement.querySelector('.content-img')).top - oTop;
    };
    /**
     * @param {?} $e
     * @return {?}
     */
    ResizingCroppingImagesComponent.prototype.moveImg = function ($e) {
        $e.stopPropagation();
        $e.preventDefault();
        var /** @type {?} */ W = this.elementRef.nativeElement.querySelector('._img').offsetWidth;
        var /** @type {?} */ H = this.elementRef.nativeElement.querySelector('._img').offsetHeight;
        var /** @type {?} */ oTop = this.elementRef.nativeElement.querySelector('._img').offsetTop;
        var /** @type {?} */ oLeft = this.elementRef.nativeElement.querySelector('._img').offsetLeft;
        if (this.stateType === 'move') {
            this._left = $e.clientX -
                offset(this.elementRef.nativeElement.querySelector('.content-img')).left - (this.centerX);
            this._top = -offset(this.elementRef.nativeElement.querySelector('.content-img')).top +
                $e.clientY - (this.centerY);
        }
        else if (this.stateType === 'resize') {
            this.resize($e, W, H, oTop, oLeft);
        }
    };
    /**
     * @param {?} ev$
     * @param {?} W
     * @param {?} H
     * @param {?} oTop
     * @param {?} oLeft
     * @return {?}
     */
    ResizingCroppingImagesComponent.prototype.resize = function (ev$, W, H, oTop, oLeft) {
        var /** @type {?} */ _W, /** @type {?} */ _H;
        var /** @type {?} */ contentImg = this.elementRef.nativeElement.querySelector('.content-img');
                                 console.log("stater 1111")
 
                    console.log("stater 1111"+this.stateR)

        if (this.stateR === 'nw') {
            this._left = -offset(contentImg).left + (ev$.clientX || ev$.pageY);
            this._top = -offset(contentImg).top +
                (ev$.clientY || ev$.pageX);
            _W = Math.round(this.elementRef.nativeElement.querySelector('._img').offsetWidth -
                (this._left - oLeft));
            _H = Math.round(this.elementRef.nativeElement.querySelector('._img').offsetHeight -
                (this._top - oTop));
            if (ev$.shiftKey) {
                this._top = (-offset(contentImg).top + (ev$.clientY ||
                    ev$.pageX)) - ((_W / this.imgWidth * this.imgHeight) - _H);
            }
        }
        else if (this.stateR === 'ne') {
            this._left = oLeft;
            this._top = -offset(contentImg).top +
                (ev$.clientY || ev$.pageY);
            _W = Math.round((-offset(contentImg).left +
                (ev$.clientX || ev$.pageX)) - oLeft);
            _H = Math.round(this.elementRef.nativeElement.querySelector('._img').offsetHeight -
                (this._top - oTop));
            if (ev$.shiftKey) {
                this._top = (-offset(contentImg).top +
                    (ev$.clientY || ev$.pageY)) - ((_W / this.imgWidth * this.imgHeight) - _H);
            }
        }
        else if (this.stateR === 'se') {
            console.log("stater"+this.stateR)
            this._left = oLeft;
            this._top = oTop;
            _W = (-offset(contentImg).left +
                (ev$.clientX || ev$.pageX)) - oLeft;
            _H = (-offset(contentImg).top +
                (ev$.clientY || ev$.pageY)) - oTop;
        }
        else if (this.stateR === 'sw') {
            // console.log('event ne', ev$);
            this._left = -offset(contentImg).left + (ev$.clientX || ev$.pageX);
            this._top = oTop;
            _W = Math.round(this.elementRef.nativeElement.querySelector('._img').offsetWidth -
                (this._left - oLeft));
            _H = Math.round((-offset(contentImg).top +
                (ev$.clientY || ev$.pageY)) - oTop);
        }
        else if (this.stateR === '-') {
            console.log("W"+W)
                        console.log("HW"+H)

            _W = W / 2;
            _H = H / 2;
            this.stateType = 'none';
            this._left = (contentImg.offsetWidth / 2) - _W / 2;
            this._top = (contentImg.offsetHeight / 2) - _H / 2;
            this.crop();
        }
        else if (this.stateR === '+') {
            _W = W * 2;
            _H = H * 2;
            this._left = (contentImg.offsetWidth / 2) - _W / 2;
            this._top = (contentImg.offsetHeight / 2) - _H / 2;
            this.stateType = 'none';
            this.crop();
        }
        if (ev$.shiftKey) {
            _H = _W / this.imgWidth * this.imgHeight;
        }
        var /** @type {?} */ fileReader = new FileReader();
        var /** @type {?} */ img;
        var /** @type {?} */ origSrc = new Image();
        var /** @type {?} */ minWidth = 80; // Change as required
        var /** @type {?} */ minHeight = 80;
        var /** @type {?} */ maxWidth = 2400; // Change as required
        var /** @type {?} */ maxHeight = 2200;
        var /** @type {?} */ cropCanvas = document.createElement('canvas');
        origSrc.src = this.origImg;
        cropCanvas.width = _W;
        cropCanvas.height = _H;
        var /** @type {?} */ ctx = cropCanvas.getContext('2d');
        ctx.drawImage(origSrc, 0, 0, // Start at 10 pixels from the left and the top of the image (crop),
        _W, _H);
        this.imgDataUrl = cropCanvas.toDataURL("image/" + this._format);
        // console.log(cropCanvas.toDataURL("image/jpeg"));
        // console.log(origSrc.width,origSrc.height);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    ResizingCroppingImagesComponent.prototype.writeValue = function (value) {
        // nothing
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    ResizingCroppingImagesComponent.prototype.registerOnTouched = function (fn) {
        this._onTouchedCallback = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    ResizingCroppingImagesComponent.prototype.registerOnChange = function (fn) {
        this._onChangeCallback = fn;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    ResizingCroppingImagesComponent.prototype.imgChange = function ($event) {
        var _this = this;
        // this._log.setLog('imgChange', $event);
        // important add converter img to size of output
        // important add converter img to size of output
        this._img = $event.target.files[0];
        this.img = $event.target.value.replace(/.*(\/|\\)/, '');
        var /** @type {?} */ fileReader = new FileReader();
        var /** @type {?} */ img;
        var /** @type {?} */ origSrc = new Image();
        var /** @type {?} */ minWidth = 80; // Change as required!!
        var /** @type {?} */ minHeight = 80;
        var /** @type {?} */ maxWidth = 2400; // Change as required
        var /** @type {?} */ maxHeight = 2200;
        var /** @type {?} */ cropCanvas = document.createElement('canvas');
        var /** @type {?} */ blank = "data:image/png;base64,iVBORw0KGg" + 'oAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAU' + "AAarVyFEAAAAASUVORK5CYII=";
        fileReader.onload = function (ev) {
            // this._log.setLog('ev', ev);
            // this._log.setLog('$event.target.files', $event.target.files);
            // this._log.setLog('$event.target.files', $event.target.files);
            // this._log.setLog('$event.target.files[0].type', $event.target.files[0].type);
            if ($event.target.files[0].type === 'image/jpeg' ||
                $event.target.files[0].type === 'image/jpg' ||
                $event.target.files[0].type === 'image/png' ||
                $event.target.files[0].type === 'image/gif') {
                _this.imgDataUrl = ev.target.result;
                _this.origImg = ev.target.result;
                origSrc.src = ev.target.result;
                img = ev.target.result;
            }
            else {
                _this.imgDataUrl = blank;
                _this.origImg = blank;
                origSrc.src = blank;
            }
            setTimeout(function () {
                _this.center();
                _this.zoom('-');
            }, 100);

            // _this.imgWidth = origSrc.width;
            // _this.imgHeight = origSrc.height;
            // _this._left = (_this.elementRef.nativeElement.querySelector('.content-img').offsetWidth / 2) -
            //     _this.imgWidth / 2;
            // _this._top = (_this.elementRef.nativeElement.querySelector('.content-img').offsetHeight / 2) -
            //     _this.imgHeight / 2;
            // ctx.drawImage(origSrc, 0, 0);
            console.warn(origSrc.width);
        };
        fileReader.readAsDataURL($event.target.files[0]);
        // console.log($event.target.files[0]);
    };
    /**
     * @return {?}
     */
    ResizingCroppingImagesComponent.prototype.center = function () {
        var _this = this;
        this.imgWidth = this.elementRef.nativeElement.querySelector('._img').offsetWidth;
        this.imgHeight = this.elementRef.nativeElement.querySelector('._img').offsetHeight;
        this._left = (this.elementRef.nativeElement.querySelector('.content-img').offsetWidth / 2) -
            this.imgWidth / 2;
        this._top = (this.elementRef.nativeElement.querySelector('.content-img').offsetHeight / 2) -
            this.imgHeight / 2;
        this.crop();
        setTimeout(function () {
            _this.crop();
        }, 10);
        setTimeout(function () {
            _this.crop();
        }, 100);
    };
    /**
     * @return {?}
     */
    ResizingCroppingImagesComponent.prototype.crop = function () {
        var /** @type {?} */ cropCanvas, /** @type {?} */ resize = this.elementRef.nativeElement.querySelector('.resize'), /** @type {?} */ left = offset(resize).left - offset(this.elementRef.nativeElement.querySelector('._img')).left, /** @type {?} */ top = offset(resize).top - offset(this.elementRef.nativeElement.querySelector('._img')).top, /** @type {?} */ width = resize.offsetWidth, /** @type {?} */ height = resize.offsetHeight;
        var /** @type {?} */ origSrc = new Image();
        origSrc.src = this.imgDataUrl;
        cropCanvas = document.createElement('canvas');
        cropCanvas.width = width;
        cropCanvas.height = height;
        cropCanvas.getContext('2d').drawImage(origSrc, left, top, width, height, 0, 0, width, height);
        this.imgCrop = cropCanvas.toDataURL("image/" + this._format);
    };
    return ResizingCroppingImagesComponent;
}());
export { ResizingCroppingImagesComponent };
ResizingCroppingImagesComponent.decorators = [
    { type: Component, args: [{
                selector: 'ly-cropping-profile',
                styles: [":host{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._img{position:absolute;display:flex}._img img{width:inherit;height:inherit;cursor:move}._img:after{position:absolute;content:'';top:0;bottom:0;left:0;right:0;pointer-events:none;border:dashed 1px;opacity:.75;color:inherit;z-index:1}/deep/ .fileUpload input[type=\"file\"]{opacity:0;position:absolute;top:0;left:0;bottom:0;right:0;cursor:pointer}.content-img{position:relative;width:100%;min-height:320px;overflow:hidden}.NoNe{display:none}.resize{position:absolute;width:300px;height:300px;top:0;pointer-events:none;bottom:0;left:0;right:0;margin:auto;box-shadow:0 0 0 1200px rgba(255,255,255,0.25),0 0 0 1px rgba(255,255,255,0),0 0 0 1px rgba(0,0,0,0.22)}.resize:before,.resize:after{content:'';background:#000;top:0;bottom:0;margin:auto;position:absolute;left:0;right:0;opacity:.25}.resize:before{width:1px;height:25px}.resize:after{width:25px;height:1px}.r_w,.r_n,.r_e,.r_s,.r_nw,.r_ne,.r_se,.r_sw{position:absolute;background:inherit}.r_w:after,.r_n:after,.r_e:after,.r_s:after,.r_nw:after,.r_ne:after,.r_se:after,.r_sw:after{position:absolute;background:inherit;content:'';width:11px;height:11px;margin:auto;opacity:.85;z-index:1}.r_w{left:0;height:100%;width:1px;cursor:w-resize}.r_w:after{right:-3px;top:0;bottom:0}.r_nw{top:-5px;left:-5px;cursor:nw-resize}.r_ne{top:-5px;right:5px;cursor:ne-resize}.r_se{bottom:5px;right:5px;cursor:se-resize}.r_sw{bottom:5px;left:-5px;cursor:sw-resize} "],
                template: "\n  <ng-content></ng-content>\n  <div class=\"content-img\"\n  (mouseleave)=\"stateType='none'; crop();\"\n  (mouseup)=\"stateType='none'; crop();\"\n  (mouseenter)=\"stateType='none'; crop();\"\n  (mousemove)=\"moveImg($event);\"\n  (dblclick)=\"center();\"\n  >\n    <div class=\"_img\"\n    [class.NoNe]=\"imgDataUrl==undefined || imgDataUrl==null\"\n    [style.top.px]=\"_top\"\n    [style.left.px]=\"_left\"\n    [ngStyle]=\"styleCrop\"\n\n    >\n      <img\n      (mousedown)=\"stateType='move'; startMove($event)\"\n      (mouseup)=\"stateType='none'\"\n      [src]=\"imgDataUrl\"\n      >\n      <span\n      class=\"r_nw\"\n      (mousedown)=\"stateType='resize'; stateR='nw'\"\n      (mouseup)=\"stateType='none'\"\n      ></span>\n      <span\n      class=\"r_ne\"\n      (mousedown)=\"stateType='resize'; stateR='ne'\"\n      (mouseup)=\"stateType='none'\"\n      ></span>\n      <span\n      class=\"r_se\"\n      (mousedown)=\"stateType='resize'; stateR='se'\"\n      (mouseup)=\"stateType='none'\"\n      ></span>\n      <span\n      class=\"r_sw\"\n      (mousedown)=\"stateType='resize'; stateR='sw'\"\n      (mouseup)=\"stateType='none'\"\n      ></span>\n    </div>\n    <div class=\"resize\"\n    [style.width.px]=\"sizeW\"\n    [style.height.px]=\"sizeH\"\n    >\n      <!--<span class=\"r_w\"></span>\n      <span class=\"r_n\"></span>\n      <span class=\"r_e\"></span>\n      <span class=\"r_s\"></span>\n      <span class=\"r_nw\"></span>\n      <span class=\"r_ne\"></span>\n      <span class=\"r_se\"></span>\n      <span class=\"r_sw\"></span>-->\n    </div>\n  </div>\n  <!--<code>{{ _log.logs | json }}</code>-->\n  ",
            },] },
];
/**
 * @nocollapse
 */
ResizingCroppingImagesComponent.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
ResizingCroppingImagesComponent.propDecorators = {
    'format': [{ type: Input, args: ['format',] },],
    'sizeW': [{ type: Input, args: ['sizeW',] },],
    'sizeH': [{ type: Input, args: ['sizeH',] },],
    'sizeWmax': [{ type: Input, args: ['sizeWmax',] },],
    'sizeHmax': [{ type: Input, args: ['sizeHmax',] },],
    'stateType': [{ type: Input, args: ['stateType',] },],
    'stateR': [{ type: Input, args: ['stateR',] },],
    'centerX': [{ type: Input, args: ['centerX',] },],
    'centerY': [{ type: Input, args: ['centerY',] },],
    'percent': [{ type: Input, args: ['percent',] },],
    'imgUrl': [{ type: Input, args: ['imgUrl',] },]
};
function ResizingCroppingImagesComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    ResizingCroppingImagesComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    ResizingCroppingImagesComponent.ctorParameters;
    /** @type {?} */
    ResizingCroppingImagesComponent.propDecorators;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype._format;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.img;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.imgDataUrl;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.origImg;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.sizeW;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.sizeH;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.sizeWmax;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.sizeHmax;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.stateMouse;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.stateType;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.stateR;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.centerX;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.centerY;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.imgWidth;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.imgHeight;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.imgCrop;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.percent;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.imgUrl;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype._top;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype._left;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype._img;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype._src;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype._onTouchedCallback;
    /**
     * Callback registered via registerOnChange (ControlValueAccessor)
     * @type {?}
     */
    ResizingCroppingImagesComponent.prototype._onChangeCallback;
    /** @type {?} */
    ResizingCroppingImagesComponent.prototype.elementRef;
}
/**
 * @param {?} e
 * @param {?} contenedor
 * @return {?}
 */
function _GEToffset(e, contenedor) {
    // Hallamos la posición relativa |posición elemento - posición real|
    var /** @type {?} */ x = contenedor.offsetLeft - e.pageX;
    var /** @type {?} */ y = contenedor.offsetTop - e.pageY;
    // console.log('contenedor.offsetLeft',contenedor.offsetLeft);
    // Hacemos el valor absoluto
    x = Math.abs(x);
    y = Math.abs(y);
    // console.log("Eje X: " + x + " " + "Eje Y: " + y);
    return { top: y, left: x };
}
/**
 * @param {?} element
 * @return {?}
 */
function getOffset(element) {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (!element) {
        return { top: 0, left: 0 };
    }
    ;
    var /** @type {?} */ y = 0;
    var /** @type {?} */ x = 0;
    while (element.offsetParent) {
        x += element.offsetLeft;
        y += element.offsetTop;
        element = element.offsetParent;
    }
    return { top: y, left: x };
}
/**
 * @param {?} el
 * @return {?}
 */
function getOffsetx(el) {
    var /** @type {?} */ _x = 0;
    var /** @type {?} */ _y = 0;
    _x += (el.offsetLeft - el.scrollLeft) - document.querySelector('ly-app').scrollLeft;
    _y += (el.offsetTop - el.scrollTop) - document.querySelector('ly-app').scrollTop;
    return { top: _y, left: _x, xleft: el.offsetLeft, xtop: el.offsetTop };
}
/**
 * @param {?} obj
 * @return {?}
 */
function isWindow(obj) {
    return obj !== null && obj === obj.window;
}
/**
 * @param {?} elem
 * @return {?}
 */
function getWindow(elem) {
    return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
}
/**
 * @param {?} elem
 * @return {?}
 */
function offset(elem) {
    var /** @type {?} */ docElem, /** @type {?} */ win, /** @type {?} */ box = { top: 0, left: 0 }, /** @type {?} */ doc = elem && elem.ownerDocument;
    docElem = doc.documentElement;
    if (typeof elem.getBoundingClientRect !== typeof undefined) {
        box = elem.getBoundingClientRect();
    }
    win = getWindow(doc);
    return {
        top: box.top + win.pageYOffset - docElem.clientTop,
        left: box.left + win.pageXOffset - docElem.clientLeft
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/resizing-cropping-images/resizing-cropping-images.js
// module id = 697
// module chunks = 31